import { Trans } from 'react-i18next'

import styled from 'styled-components'
import interestsSharedPNG from '~/assets/images/art/interests-shared.png'
import interestsSharedWEBP from '~/assets/images/art/interests-shared.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const ImageWrapper = styled(S.ImageWrapper)`
  width: 280px;
  max-width: 100%;
  margin: 0 auto;
`

const InterestsSharedArt = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Thanks for sharing your interests',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <ImageWrapper>
          <picture>
            <source srcSet={interestsSharedWEBP} type="image/webp" />
            <img src={interestsSharedPNG} alt="Thanks for sharing" />
          </picture>
        </ImageWrapper>

        <S.Title>
          <Trans ns="art" i18nKey="onboarding.interestsSharedArt.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="art" i18nKey="onboarding.interestsSharedArt.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default InterestsSharedArt
